import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme
} from '@mui/material';
import moment from 'moment';
import { IGroupPortal } from 'src/models/groupPortal';
import { t } from 'i18next';

interface IProps {
  groupPortals: IGroupPortal[];
  loading?: boolean;
  selectedGroupByIds: string[] | undefined;
  onClick: (group: IGroupPortal) => void;
}

const TableSelectGroupPortal = ({
  groupPortals,
  loading = false,
  selectedGroupByIds,
  onClick
}: IProps) => {
  const theme = useTheme();

  return (
    <TableContainer component={Paper} sx={{ maxHeight: theme.spacing(30) }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>{t('no')}</TableCell>
            <TableCell>{t('group')}</TableCell>
            <TableCell align="center">{t('added')}</TableCell>
            <TableCell align="center">{t('portal count')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {groupPortals.map((row, index) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              hover
              onClick={() => onClick(row)}
            >
              <TableCell component="th" scope="row">
                <Checkbox
                  checked={selectedGroupByIds.includes(row.id)}
                  value={row.id}
                  name="group-portal"
                  size="small"
                  sx={{ color: theme.palette.primary.main }}
                />
              </TableCell>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.displayName}</TableCell>
              <TableCell align="center">
                {row.createdAt === '-'
                  ? '-'
                  : moment(row.createdAt).format('D/MM/YY')}
              </TableCell>
              <TableCell align="center">
                {row.id === '_default' ? '' : row.portals.length}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSelectGroupPortal;
